import { DocumentNode, gql } from '@apollo/client';
import {
  BoxProps,
  HStack,
  LinkBox,
  LinkOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { convertFromRaw } from 'draft-js';
import NextLink from 'next/link';
import * as React from 'react';

import { usePostHref } from '@/hooks/usePostHref';
import { LayoutIcon } from '@/imports/ui/chakra/feather';

import { BlogAnnouncement_BlogFragment } from './graphql-types/BlogAnnouncement_BlogFragment';

import { Card } from '../Card';

const POST_FRAGMENT = gql`
  fragment BlogAnnouncement_BlogFragment on BlogV2 {
    _id
    blogTitle: title
    blogBody: content
  }
`;

export const Blog: React.FC<
  { blog: BlogAnnouncement_BlogFragment } & BoxProps
> & {
  blogFragment: DocumentNode;
} = ({ blog, children, ...rest }) => {
  const postHref = usePostHref(blog._id);

  return (
    <LinkBox>
      <Card {...rest}>
        <VStack overflow="hidden" alignItems="start" spacing="0">
          <HStack>
            <LayoutIcon color="gray.500" />
            <Text textStyle="detail" color="gray.500" fontWeight="600">
              <LinkOverlay as={NextLink} href={postHref}>
                ARTICLE
              </LinkOverlay>
            </Text>
          </HStack>
          <Text noOfLines={2} textStyle="bodyStrong">
            {blog.blogTitle}
          </Text>
          <Text noOfLines={3} textStyle="detail">
            {convertFromRaw(blog.blogBody).getPlainText()}
          </Text>
        </VStack>
      </Card>
      {children}
    </LinkBox>
  );
};
Blog.blogFragment = POST_FRAGMENT;
